import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search',
})
export class SearchPipe implements PipeTransform {
  transform<T>(items: T[], searchKey: string, property: keyof T): T[] {
    if (!Array.isArray(items) || !searchKey || !property) {
      return items;
    }

    const lowerCaseSearchKey = searchKey.trim().toLowerCase();

    return items.filter(item => {
      const value = item[property];
      return typeof value === 'string' && value.toLowerCase().includes(lowerCaseSearchKey);
    });
  }
}
